<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <div style="height: 0.5rem;">
                        <v-progress-linear
                                v-show="loading"
                                height="8"
                                indeterminate
                                color="primary"
                        ></v-progress-linear>
                    </div>
                    <v-card-text>


                        <v-container>
                            <v-row class="header-image-container">

                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <i18n path="invitation.helloTextWithContext" tag="p" class="text-justify"
                                          v-if="context">
                                        <span slot="context"><span class="font-weight-bold">{{ context }}</span></span>
                                    </i18n>
                                    <p v-else class="text-justify">
                                        {{ $t("invitation.helloText") }}
                                    </p>

                                    <v-alert v-show="error" type="error"
                                             transition="scale-transition">
                                        {{error}}
                                    </v-alert>

                                    <v-form @keyup.native.enter="submit">
                                        <v-select
                                                :items="sexItems"
                                                :label="$t('common.pleaseChoose') + '*'"
                                                name="sex"
                                                v-model="user.sex"

                                                :error-messages="sexErrors"
                                                @input="$v.user.sex.$touch()"
                                                @blur="$v.user.sex.$touch()"
                                        ></v-select>
                                        <v-text-field
                                                autofocus
                                                :label="$t('common.firstname') + '*'"
                                                name="firstName"
                                                type="text"
                                                v-model="user.firstName"

                                                :error-messages="firstnameErrors"
                                                @input="$v.user.firstName.$touch()"
                                                @blur="$v.user.firstName.$touch()"
                                        ></v-text-field>
                                        <v-text-field
                                                :label="$t('common.lastname') + '*'"
                                                name="lastName"
                                                type="text"
                                                v-model="user.lastName"

                                                :error-messages="lastnameErrors"
                                                @input="$v.user.lastName.$touch()"
                                                @blur="$v.user.lastName.$touch()"
                                        ></v-text-field>
                                        <v-text-field
                                                :label="$t('common.username') + '*'"
                                                name="userName"
                                                type="text"
                                                disabled
                                                v-show="user.userName"
                                                v-model="user.userName"
                                        ></v-text-field>
                                        <v-text-field
                                                id="password"
                                                :label="$t('common.createPassword') + '*'"
                                                name="password"
                                                v-model="user.password"


                                                :type="showPassword ? 'text' : 'password'"
                                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                @click:append="showPassword = !showPassword"

                                                :error-messages="passwordErrors"
                                                @input="$v.user.password.$touch()"
                                                @blur="$v.user.password.$touch()"
                                        ></v-text-field>
                                        <password
                                                v-model="user.password"
                                                :secureLength="8"
                                                :strength-meter-only="true"
                                        ></password>
                                        <v-text-field
                                                id="password_confirm"
                                                :label="$t('common.confirmPassword') + '*'"
                                                name="password_confirm"
                                                v-model="user.passwordConfirm"

                                                :type="showPasswordConfirm ? 'text' : 'password'"
                                                :append-icon="showPasswordConfirm ? 'visibility' : 'visibility_off'"
                                                @click:append="showPasswordConfirm = !showPasswordConfirm"

                                                :error-messages="passwordConfirmErrors"
                                                @input="$v.user.passwordConfirm.$touch()"
                                                @blur="$v.user.passwordConfirm.$touch()"
                                        ></v-text-field>
                                        <v-checkbox v-model="rules"

                                                    :error-messages="rulesErrors"
                                                    @change="$v.rules.$touch()">
                                            <i18n path="common.agb" tag="span" slot="label">
                                                <span slot="tos"> <a @click.stop target="_blank"
                                                                     href='https://onsharesuite.com/files/AGBs.pdf'>{{ $t('common.tos')}}</a></span>
                                                <span slot="dataPrivacy"><a @click.stop target="_blank"
                                                                            href='https://www.sharesuite.com/datenschutz/'>{{ $t('common.dataPrivacy')}}</a></span>
                                            </i18n>
                                        </v-checkbox>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container>
                            <v-row
                            >
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-btn x-large color="success" class="register-button" @click="submit"
                                           :disabled="loading">
                                        {{ $t('common.register')}}
                                    </v-btn>

                                </v-col>
                            </v-row>

                            <v-row
                            >
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >

                                    <router-link
                                            class="caption"
                                            :to="{ name: 'join' }">
                                        {{ $t('common.loginLink') }}
                                    </router-link>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {required, minLength, sameAs} from 'vuelidate/lib/validators'
    import Password from 'vue-password-strength-meter'

    export default {
        name: 'InviteRegister',
        components: { Password },

        validations: {
            user: {
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                password: {
                    required,
                    minLength: minLength(8)
                },
                passwordConfirm: {
                    required,
                    minLength: minLength(8),
                    sameAsPassword: sameAs('password')
                },
                sex: {
                    required
                },
            },
            rules: {
                sameAs: sameAs( () => true )
            }
        },

        data: () => ({
            loading: false,
            error: null,

            context: '',

            showPassword: false,
            showPasswordConfirm: false,

            user: {
                firstName: '',
                lastName: '',
                password: '',
                passwordConfirm: '',
                sex: null,
                userName: ''
            },
            rules: null
        }),
        computed: {
            sexItems: function() {
                return [{
                    text: this.$t('common.male'),
                    value: 'MALE'
                }, {
                    text: this.$t('common.female'),
                    value: 'FEMALE'
                }]
            },
            sexErrors() {
                const errors = []

                if(!this.$v.user.sex.$dirty) {
                    return errors
                }

                !this.$v.user.sex.required && errors.push(this.$t('common.errors.fieldRequired'))
                return errors
            },
            firstnameErrors() {
                const errors = []

                if(!this.$v.user.firstName.$dirty) {
                    return errors
                }

                !this.$v.user.firstName.required && errors.push(this.$t('common.errors.fieldRequired'))
                return errors
            },
            lastnameErrors() {
                const errors = []

                if(!this.$v.user.lastName.$dirty) {
                    return errors
                }

                !this.$v.user.lastName.required && errors.push(this.$t('common.errors.fieldRequired'))
                return errors
            },
            passwordErrors() {
                const errors = []

                if(!this.$v.user.password.$dirty) {
                    return errors
                }

                !this.$v.user.password.required && errors.push(this.$t('common.errors.fieldRequired'))
                !this.$v.user.password.minLength && errors.push(this.$t('common.errors.fieldMinLength', {amount: 8}))

                return errors
            },
            passwordConfirmErrors() {
                const errors = []

                if(!this.$v.user.passwordConfirm.$dirty) {
                    return errors
                }

                !this.$v.user.passwordConfirm.required && errors.push(this.$t('common.errors.fieldRequired'))
                this.$v.user.passwordConfirm.$model !== this.$v.user.password.$model && errors.push(this.$t('common.errors.passwordConfirmError'))
                !this.$v.user.passwordConfirm.minLength && errors.push(this.$t('common.errors.fieldMinLength', {amount: 8}))

                return errors
            },

            rulesErrors() {
                const errors = []

                if(!this.$v.rules.$dirty) {
                    return errors
                }

                !this.$v.rules.sameAs && errors.push(this.$t('common.errors.fieldRequired'))
                return errors
            }
        },

        created() {
            const username = this.$route.query.user;
            const context = this.$route.query.ctx;

            if(typeof username !== 'undefined') {
                this.user.userName = username;
            }

            if(typeof context !== 'undefined') {
                this.context = context;
            }

            this.loading = true;
            this.$store.dispatch('checkInvitation', {
              token: this.$route.query.token
            }).then((responseData) => {
                if(responseData === 'JOIN') {
                  location.hash = location.hash.replace(
                      "/invitation/register",
                      "/invitation/join"
                  )
                } else if(responseData === 'START'){
                  location.replace(location.origin + "/" + process.env.VUE_APP_WEB_APP_PATH);
                }
            }).catch((response) => {
                switch(response.status) {
                  case 409:
                    this.error = this.$t('common.errors.userExists');
                    break;
                  case 406: // Invitation has been used
                  case 404: // Invitation not found or expired
                    this.error = this.$t('invitation.errors.invitationExpired');
                    break;
                  default:
                  // Unexpected system errors
                    this.error = this.$t('common.errors.commonError')
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        methods: {
            submit() {
                this.$v.$touch()
                if(!this.$v.$invalid) {
                    this.error = null;
                    this.loading = true;

                    this.$store.dispatch('registerByInvitation', {
                        token: this.$route.query.token,
                        user: {...this.user, subscribeNewsletter: false}
                    }).then((response) => {
                       // Login after register
                      this.$store.dispatch("login", { user : this.user})
                          .then((responseData) => {
                            if(responseData.success === true && responseData.result !== false && responseData.result.user) {
                              this.$router.push({name: 'register_success'})
                            } else {
                              this.error = this.$t('join.errors.loginFailed');
                            }
                          }).catch((response) => {
                            const appId = response.data.result.appId;
                            const errorId = response.data.result.errorId;
                            if(appId === 0 && errorId === 11) {
                                this.$router.push({name: 'register_success'})
                            } else {
                                this.error = this.$t('join.errors.loginFailed');
                            }
                          });
                    }).catch((response) => {
                        switch(response.status) {
                            case 409:
                                this.error = this.$t('common.errors.userExists');
                                break;
                            case 406: // Invitation has been used
                            case 404: // Invitation not found or expired
                                this.error = this.$t('invitation.errors.invitationExpired');
                                break;
                            default:
                                // Unexpected system errors
                                this.error = this.$t('common.errors.commonError')
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .register-button {
        width: 100%;
        text-transform: initial;
    }

    .v-card__text {
        padding-top: 0;
        padding-bottom: 0 !important;
    }

    .header-image-container {
        height: 75px;
    }
</style>
